import { HttpUtilService, Logger, HttpClient, HttpResponse, HttpRequestInit, AgentSessionManager, ApiUriConstants } from '@nice-ccf/core-sdk';

/**
 * Class to handling contact services
 */
export class ContactService {
  logger: Logger = new Logger('acd', 'ContactService');
  protected utilService: HttpUtilService = new HttpUtilService();
  private agentSession : AgentSessionManager = <AgentSessionManager>{};

  /**
   * @example
   * ```
   * const contactSvc = new ContactService();
   * ```
   */
  constructor() {
    this.agentSession = AgentSessionManager.instance;
  }

  /**
   * This method to end the contact
   * @param contactId -  contact id
   * @example
   * ```
   * endContact(23423423);
   * ```
   */
  public endContact(contactId: number): Promise<HttpResponse> {
    const sessionId = this.agentSession.getSessionId();
    const baseUrl = this.agentSession.auth.getCXoneConfig().acdApiBaseUri;
    const authToken = this.agentSession.auth.getAuthToken().accessToken;
    const reqInit: HttpRequestInit = this.utilService.initHeader(authToken);
    const url = baseUrl + ApiUriConstants.END_CONTACT_URI.replace('{sessionId}', sessionId).replace('{contactId}', contactId.toString());

    return new Promise((resolve, reject) => {
      HttpClient.post(url, reqInit).then(
        (response: HttpResponse) => {
          this.logger.debug('endContact', 'end contact success:-' + response.toString());
          resolve(response);
        },
        (error) => {
          this.logger.error('endContact', 'end contact failed:-' + error.toString());
          reject(error);
        }
      );
    });
  };

  /**
   * This method to accept the incoming contact
   * @param contactId -  contact id
   * @example
   * ```
   * acceptContact(23423423);
   * ```
   */
   public acceptContact(contactId: number): Promise<HttpResponse> {
    const sessionId = this.agentSession.getSessionId();
    const baseUrl = this.agentSession.auth.getCXoneConfig().acdApiBaseUri;
    const authToken = this.agentSession.auth.getAuthToken().accessToken;
    const reqInit: HttpRequestInit = this.utilService.initHeader(authToken);
    const url = baseUrl + ApiUriConstants.ACCEPT_CONTACT_URI.replace('{sessionId}', sessionId).replace('{contactId}', contactId.toString());

    return new Promise((resolve, reject) => {
      HttpClient.post(url, reqInit).then(
        (response: HttpResponse) => {
          this.logger.debug('acceptContact', 'acceptContact success:-' + response.toString());
          resolve(response);
        },
        (error) => {
          this.logger.error('acceptContact', 'acceptContact failed:-' + error.toString());
          reject(error);
        }
      );
    });
  };

  /**
   * This method to reject the incoming contact
   * @param contactId -  contact id
   * @example
   * ```
   * rejectContact(23423423);
   * ```
   */
   public rejectContact(contactId: number): Promise<HttpResponse> {
    const sessionId = this.agentSession.getSessionId();
    const baseUrl = this.agentSession.auth.getCXoneConfig().acdApiBaseUri;
    const authToken = this.agentSession.auth.getAuthToken().accessToken;
    const reqInit: HttpRequestInit = this.utilService.initHeader(authToken);
    const url = baseUrl + ApiUriConstants.REJECT_CONTACT_URI.replace('{sessionId}', sessionId).replace('{contactId}', contactId.toString());

    return new Promise((resolve, reject) => {
      HttpClient.post(url, reqInit).then(
        (response: HttpResponse) => {
          this.logger.debug('rejectContact', 'rejectContact success:-' + response.toString());
          resolve(response);
        },
        (error) => {
          this.logger.error('rejectContact', 'rejectContact failed:-' + error.toString());
          reject(error);
        }
      );
    });
  }
}
